<template>
  <span class="badge bg-secondary px-2 py-1 rounded-3 d-flex align-items-center g-1" style="font-size: 0.95em">
    <i class="fas fa-circle" style="font-size: 0.85em" :style="{ color: color }"></i>
    <span>{{ role.name }}</span>
  </span>
</template>

<script>
export default {
  name: "RoleView",
  props: {
    role: Object
  },
  computed: {
    color() {
      return this.role.color;
    }
  }
}
</script>